import { useShallow } from 'zustand/react/shallow';
import { PlantCard } from './plant-card.tsx';
import { PlantsWithOverview } from '@/features/plants/hooks/queries/use-get-plants.tsx';
import { PlantsTable } from './plants-table/plants-table.tsx';
import { usePlantsFilter } from '@/features/plants/hooks/use-plants-filter.ts';
import { usePlantsViewFilterStore } from '@/services/store/use-plants-view-filter-store.ts';

export const PlantsList = () => {
  const { plants, isLoading } = usePlantsFilter();
  const { view, layout } = usePlantsViewFilterStore(
    useShallow((state) => ({
      view: state.view,
      layout: state.layout,
    }))
  );

  const getViewType = (plant: PlantsWithOverview) => {
    const setupPlantType = plant.technicalSpecifications.setupType;

    let viewType = 'production-only';

    if (setupPlantType === 'storage-only') {
      viewType = 'storage-only';
    }

    if (setupPlantType === 'storage-only' && view === 'storage') {
      viewType = 'storage-only';
    }

    if (setupPlantType === 'production-only' && view === 'production') {
      viewType = 'production-only';
    }

    if (setupPlantType === 'production-storage' && view === 'storage') {
      viewType = 'storage-only';
    }

    return viewType;
  };

  if (isLoading) {
    return (
      <ul className="grid grid-cols-1 gap-6 min-[1101px]:grid-cols-2 min-[1651px]:grid-cols-3">
        {Array(6)
          .fill(() => null)
          .map((_, index) => (
            <li
              key={index}
              className="plant-grid-item h-[176px] overflow-hidden rounded-xl bg-white/80"
            >
              <div className="w-full"></div>
            </li>
          ))}
      </ul>
    );
  }

  if (layout === 'table') {
    return <PlantsTable data={plants} isLoading={false} viewType={view} />;
  }

  return (
    <ul className="grid grid-cols-1 gap-6 min-[1101px]:grid-cols-2 min-[1651px]:grid-cols-3">
      {plants?.map((plant) => (
        <PlantCard plant={plant} key={plant.plantId} viewType={getViewType(plant)} />
      ))}
    </ul>
  );
};
